const ConsentPendingIcon = ({
  height = "24px",
  width = "24px",
}: {
  height?: string;
  width?: string;
}) => {
  return (
    <svg
      style={{ width: `${width}`, height: `${height}` }} // Use inline styles here
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75Z"
        fill="#FFD9D6"
      />
      <path
        d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96452 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7474 9.41495 20.7193 6.93654 18.8914 5.10863C17.0635 3.28073 14.5851 2.25265 12 2.25ZM12 20.25C10.3683 20.25 8.77326 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75358 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32015 6.16637 6.16637C7.32016 5.01259 8.79017 4.22685 10.3905 3.90852C11.9909 3.59019 13.6497 3.75357 15.1571 4.37799C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7661 8.77325 20.25 10.3683 20.25 12C20.2474 14.1872 19.3773 16.2841 17.8307 17.8307C16.2841 19.3773 14.1872 20.2474 12 20.25ZM15.53 14.47C15.6705 14.6106 15.7493 14.8012 15.7493 15C15.7493 15.1988 15.6705 15.3894 15.53 15.53C15.3894 15.6705 15.1988 15.7493 15 15.7493C14.8013 15.7493 14.6106 15.6705 14.47 15.53L11.47 12.53C11.3293 12.3895 11.2502 12.1988 11.25 12V6C11.25 5.80109 11.329 5.61032 11.4697 5.46967C11.6103 5.32902 11.8011 5.25 12 5.25C12.1989 5.25 12.3897 5.32902 12.5303 5.46967C12.671 5.61032 12.75 5.80109 12.75 6V11.69L15.53 14.47Z"
        fill="#E62D38"
      />
    </svg>
  );
};
export default ConsentPendingIcon;
